import { useEffect } from "react";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import {
    useForm,
    useFetch,
    useToast,
    usePopup,
    useTheme,
    useStore,
    useGrid,
    useModal,
    useResource,
} from "@/comn/hooks";
import { BASE, APIS, SF_USR_M_SRCH, SG_USR_M_LIST } from "./services/OsciComnPpupService";

export const UsrList = (props: any) => {
    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "OSC0088" }],
    });

    const pgeUid = "usrLst";
    const { t } = useTranslation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal();
    const { close, postMessage, getParams } = usePopup();
    const params = getParams(); /* * */
    const { theme } = useTheme();

    const form = {
        usrSrch: useForm({
            defaultSchema: SF_USR_M_SRCH,
            defaultValues: { ...pgeStore?.form, tin: params?.tin || "" } || {},
        }),
    };

    const grid = {
        usrLst: useGrid({
            defaultSchema: SG_USR_M_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getUsrLst: useFetch({
            api: (page = grid.usrLst.page) => {
                return APIS.getUsrLst(form.usrSrch.getValues(), page, grid.usrLst.size);
            },
            enabled: comnUtils.isEmpty(form.usrSrch.errors) && form.usrSrch.isSubmitted,
            key: [grid.usrLst.page, grid.usrLst.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.usrSrch.getValues(),
                    page: grid.usrLst.page,
                    size: grid.usrLst.size,
                });
            },
        }),
    };

    const handler = {
        click_Btn_Srch: () => {
            form.usrSrch.handleSubmit(
                () => {
                    grid.usrLst.setPage(0);
                    fetch.getUsrLst.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
        /* * */
        click_Btn_Apply: () => {
            const list: any[] = grid.usrLst.getChecked() || [];
            if (comnUtils.isEmpty(list)) {
                modal.openModal({ content: "msg.osc.00084" });
                return;
            }

            postMessage({ data: list });
            close();
        },
    };

    const render = {
        grid_UsrLst: {
            cell: {
                userName: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <a
                            href="#!"
                            onClick={() => {
                                if (!comnUtils.isPopup()) return;

                                postMessage({
                                    code: rowValues.userId,
                                    label: rowValues.userName,
                                    roles: rowValues.roles,
                                    stat: rowValues.userStatus,
                                });
                                close();
                            }}
                        >
                            {value}
                        </a>
                    );
                },
            },
        },
    };

    useEffect(() => {
        handler.click_Btn_Srch();
        /* * */
        if (params?.multiple === true) {
            grid.usrLst.setOption("checkbox", true);
        }
    }, []);

    return (
        <Page
            id={pgeUid}
            title={t("L_USR_LST")}
            navigation={{
                base: comnEnvs.base,
                nodes: [...BASE.nodes, { label: "L_USR_LST" }],
            }}
        >
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.usrSrch.schema.userName}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                onClick={() => {
                                    form.usrSrch.reset();
                                    handler.click_Btn_Srch();
                                }}
                            >
                                {t("B_RESET")}
                            </Button>
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                onClick={() => {
                                    handler.click_Btn_Srch();
                                }}
                            >
                                {t("B_SRCH")}
                            </Button>
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Section>
                        {params?.multiple === true && (
                            <Layout>
                                <Layout.Right>
                                    <Button
                                        role="apply"
                                        onClick={() => {
                                            handler.click_Btn_Apply();
                                        }}
                                    ></Button>
                                </Layout.Right>
                            </Layout>
                        )}
                        <Grid {...grid.usrLst.grid} data={fetch.getUsrLst.data?.usrList} render={render.grid_UsrLst} />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
